import React from "react";
import _ from "lodash";
import numeral from "numeral";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

class RequestScoreView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      columns: [],
      groups: [],
      amount: null,

      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      tags: [],
      alias: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns } = this.props;

    const arrangeCol = [
      {
        key: "ext_gam_unit_id",
        label: "Ext Gam Unit Id",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        dataKey: "p_score",
        key: "cv",
        label: "cv",
        mainGroup: true,
        groupfunc: (list) => {
          const pList = _.filter(list, (d) => _.isNumber(d));
          if (pList.length === 0) return (0).toFixed(2);
          const pNumList = _.map(pList, (d) => _.toNumber(d.toFixed(4)));
          const pSum = _.sum(pNumList);
          const pAvg = pSum / pNumList.length;
          if (pAvg === 0) return 0;
          const variance =
            _.reduce(
              pNumList,
              (sum, d) => {
                const diff = d - pAvg;
                return sum + diff * diff;
              },
              0
            ) / pNumList.length;
          const stdDev = Math.sqrt(variance);
          const cv = stdDev / pAvg;
          return _.toNumber(cv.toFixed(2));
        },
      },
      {
        key: "p_score",
        label: "P Score",
        parsefunc: ({ billing_key_tagged_request, total_request }) => {
          return total_request === 0
            ? 0
            : billing_key_tagged_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "d_score",
        label: "D Score",
        parsefunc: ({ optimized_request, billing_key_tagged_request }) => {
          return billing_key_tagged_request === 0
            ? 0
            : optimized_request / billing_key_tagged_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "uprkey_score",
        label: "upr key score",
        parsefunc: ({ key20_tagged_request, billing_key_tagged_request }) => {
          return billing_key_tagged_request === 0
            ? 0
            : key20_tagged_request / billing_key_tagged_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "total_request",
        label: "total #",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "billing_key_tagged_request",
        label: "bk #",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "optimized_request",
        label: "o #",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "key20_tagged_request",
        label: "key20 #",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
    ];

    const result = parseTableData({
      columns,
      arrangeColumns: arrangeCol,
      records,
      mainKey: "ext_gam_unit_id",
      orderKey: "total_request",
    });

    this.setState({
      ...result,
      filterGroups: result.groups,
      filterRecords: result.records,
      filterAmount: result.amount,
      columns: arrangeCol,
      tags: arrangeCol.slice(3).map((item) => ({
        value: item.key,
        label: item.label,
      })),
      alias: [
        {
          value:
            "total_request >= 10000 AND (p_score <= 0.95 OR (d_score <= 0.88 OR d_score >=0.92) OR uprkey_score <= 0.95)",
          label: "Quick Filter",
        },
        {
          func: (inputValue) =>
            `total_request >= 10000 AND (p_score <= 0.95 OR (d_score <= ${(
              inputValue - 0.02
            ).toFixed(2)} OR d_score >= ${(inputValue + 0.02).toFixed(
              2
            )}) OR uprkey_score <= 0.95)`,
          label: "Custom D Score",
        },
      ],
    });
  }

  handleSearch(expression) {
    const { records, columns } = this.state;

    const result = filterDataToGroup({
      expression,
      records,
      columns,
    });

    if (result) {
      this.setState({
        ...result,
      });
    }
  }

  render() {
    const { columns, tags, filterAmount, filterGroups, filterRecords, alias } =
      this.state;

    return (
      <>
        <div className="mb-2">
          <FilterControl
            tags={tags}
            alias={alias}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>

        <GroupDataTable
          records={filterRecords}
          groups={filterGroups}
          amount={filterAmount}
          mainKey="ext_gam_unit_id"
          columns={columns}
        ></GroupDataTable>
      </>
    );
  }
}
export default RequestScoreView;
